// Mini tablero «Ahora» de la tarjeta de la unidad (en Mapon: distancia,
// conduciendo y detenido del día). Sale del mismo scoreDriving del día que ya
// calcula la tarjeta para la calificación: no cuesta otra lectura.
import type { DrivingScore } from "../../pages/reports/utils/drivingScore";

export interface TodaySummary {
  km: number;
  drivingMs: number;
  idleMs: number;
  // Lo que va del día sin manejar ni ralentí: detenida con motor apagado o sin
  // reportar (no se distinguen sin otra lectura).
  stoppedMs: number;
  avgSpeed: number | null;
}

export const todaySummary = (score: DrivingScore, dayStartMs: number, nowMs: number): TodaySummary => {
  const elapsed = Math.max(0, nowMs - dayStartMs);
  return {
    km: score.distanceKm,
    drivingMs: score.drivingMs,
    idleMs: score.idleMs,
    stoppedMs: Math.max(0, elapsed - score.drivingMs - score.idleMs),
    avgSpeed: score.avgSpeed,
  };
};

/** «2 h 31 min», «12 min», «0 min». */
export const fmtDuration = (ms: number): string => {
  const min = Math.round(ms / 60000);
  const h = Math.floor(min / 60);
  const m = min % 60;
  return h > 0 ? `${h} h ${m} min` : `${m} min`;
};

/** «79.4 km» con un decimal debajo de 100 y sin decimales arriba. */
export const fmtKm = (km: number): string => `${km < 100 ? km.toFixed(1) : Math.round(km).toLocaleString("es-MX")} km`;
